import React from "react";
import { useSelector } from "react-redux";
import { newsletterone } from "../redux/selectors";


const NewsletterOne = () => {
  const data = useSelector(newsletterone("landing"));

    return (
        <section className="organic-food mt-32">
            <div className="delivery-section">
                <div className="newsletter">
                    <div className="container container-lg">
                        <img
                            className="rounded-16 w-100 h-100"
                            src={data?.content[0]?.image?.files?.original?.url}
                            alt=""
                        />
                    </div>
                </div>
            </div>
        </section>
        // <div className="newsletter mt-32">
        //     <div className="container container-lg">
        //         <div className="newsletter-box  position-relative rounded-16 flex-align gap-16 flex-wrap z-1">
        //             <img
        //                 className="rounded-16 position-absolute inset-block-start-0 inset-inline-start-0 z-n1 w-100 h-100"
        //                 src="assets/images/bg/Outer_color.png"
        //                 alt=""
        //             />
        //             <div className="row align-items-center">
        //                 {/* <div className="col-xl-1"></div> */}
        //                 <div className="col-xl-6">
        //                     <div>
        //                         <h2 className="text-white mb-20">{data?.title}</h2>
        //                         <p className="text-white h5 mb-0">
        //                         {data?.desc}
        //                         </p>
        //                         <form action="#" className="position-relative mt-40">
        //                         <input
        //                             type="text"
        //                             className="form-control common-input rounded-pill bg-main-product-50 text-white py-22 px-16 pe-144"
        //                             placeholder="Your email address..."
        //                         />
        //                         <Link
        //                             to="/"
        //                             className="btn rounded-pill bg-main-product-50 hover-bg-main-product-50 position-absolute top-50 translate-middle-y inset-inline-end-0 me-10"
        //                         >
        //                             Subscribe
        //                         </Link>
        //                         </form> 
        //                     </div>
        //                 </div>
        //                 <div className="col-xl-6 text-center d-xl-block d-none">
        //                     <img
        //                         src={data?.content[0]?.image?.files?.original?.url}
        //                         alt=""
        //                         style={{ width: "583px", height: "377px" }}
        //                     />
        //                 </div>
        //             </div>
        //         {/* <div className="col-xl-6 text-center d-xl-block d-none">
        //             <img
        //             src={data[0]?.image?.files?.original?.url}
        //             alt=""
        //             style={{ width: "583px", height: "377px" }}
        //             />
        //         </div> */}
        //         </div>
        //     </div>
        // </div>
    );
};

export default NewsletterOne;
